import React, { FC } from 'react';

import { ArrowUpOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import CountUp from 'react-countup';
import { T } from 'react-translator-component';

import * as S from './styled';

import thunderIcon from '../../../assets/redThunder.png';
import { isMonetizationProUser } from '../../../utils/isMonetizationProUser/isMonetizationProUser';
import { isTerpelTenant } from '../../../utils/isTerpelTenant/isTerpelTenant';
import BarsIcon from '../../atoms/icons/BarsIcon';
import WaveDownIcon from '../../atoms/icons/WaveDownIcon';
import WaveUpIcon from '../../atoms/icons/WaveUpIcon';
import Card from '../../molecules/Card';

export type CardDescriptionProps = {
  iconColor: string;
};

export const CardDescription: FC<CardDescriptionProps> = ({ iconColor }) => (
  <S.Legend>
    <ArrowUpOutlined style={{ color: iconColor }} />
    <p className='description_registered--portrait'>{T('Period Total')}</p>
  </S.Legend>
);

export type HomeIndicatorsPortraitProps = {
  allStats: any;
  energyLoading: boolean;
  costLoading: boolean;
  incomeLoading: boolean;
};

const HomeIndicatorsPortrait: FC<HomeIndicatorsPortraitProps> = ({
  allStats,
  energyLoading,
  costLoading,
  incomeLoading,
}) => {
  const user: any = JSON.parse(localStorage.getItem('auth-user') as any);

  const shouldShowFinancialCards = user?.permissions.some(
    (permission) =>
      permission.route === '/financial-indicators' && !!permission.status,
  );

  return (
    <S.IndicatorsPortraitWrapper>
      {energyLoading ? (
        <S.SkeletonPortrait>
          <Skeleton.Button active />
        </S.SkeletonPortrait>
      ) : (
        <Card
          minWidth={260}
          title={
            <S.TitleWithNormalText>
              {T('CONSUMED kWh TOTAL')}
            </S.TitleWithNormalText>
          }
          noPadding
          titlePadding
          indicators={[
            {
              values: (
                <S.CardWrapper>
                  <S.FlexCenter>
                    <img
                      src={thunderIcon}
                      alt='thunder icon'
                      width={50}
                      height={50}
                    />

                    <CountUp
                      className='number_charged--energy'
                      start={0}
                      end={
                        allStats?.energy?.consumption
                          ? Number(allStats?.energy?.consumption?.toFixed(2))
                          : 0
                      }
                      duration={3}
                      decimals={2}
                      separator='.'
                      decimal=','
                    />
                  </S.FlexCenter>

                  <S.WaverUpWrapper>
                    <WaveUpIcon width='100%' height='100' fill='#3a89ff' />
                  </S.WaverUpWrapper>
                </S.CardWrapper>
              ),
              labels: <CardDescription iconColor='#3a89ff' />,
              width: '100%',
            },
          ]}
        />
      )}

      {shouldShowFinancialCards &&
        (isMonetizationProUser() || isTerpelTenant()) && (
          <>
            {costLoading ? (
              <S.SkeletonPortrait>
                <Skeleton.Button active />
              </S.SkeletonPortrait>
            ) : (
              <Card
                minWidth={260}
                title='Custo estimado no período'
                noPadding
                titlePadding
                indicators={[
                  {
                    values: (
                      <S.CardWrapper>
                        <CountUp
                          className='number_charged--energy-countup'
                          prefix={`${allStats?.energy?.coin ?? ''}  `}
                          start={0}
                          end={(allStats?.energy?.monthCost as any) || 0}
                          duration={3}
                          decimals={2}
                          separator='.'
                          decimal=','
                        />
                        <S.BarsWrapper>
                          <BarsIcon width='100%' height='160' />
                        </S.BarsWrapper>
                      </S.CardWrapper>
                    ),
                    labels: <CardDescription iconColor='#EA4235' />,
                    width: '100%',
                  },
                ]}
              />
            )}

            {incomeLoading ? (
              <S.SkeletonPortrait>
                <Skeleton.Button active />
              </S.SkeletonPortrait>
            ) : (
              <Card
                noPadding
                title='Receita estimada no período'
                minWidth={260}
                titlePadding
                indicators={[
                  {
                    values: (
                      <S.CardWrapper>
                        <CountUp
                          className='number_charged--energy-value'
                          prefix={`${allStats?.energy?.coin ?? ''}  `}
                          start={0}
                          end={(allStats?.energy?.monthIncome as any) || 0}
                          duration={3}
                          decimals={2}
                          separator='.'
                          decimal=','
                        />
                        <S.WaverDownWrapper>
                          <WaveDownIcon
                            width='100%'
                            height='115'
                            fill='#1CAF9A'
                          />
                        </S.WaverDownWrapper>
                      </S.CardWrapper>
                    ),
                    labels: <CardDescription iconColor='#1CAF9A' />,
                    width: '100%',
                  },
                ]}
              />
            )}
          </>
        )}
    </S.IndicatorsPortraitWrapper>
  );
};

export default HomeIndicatorsPortrait;
